define('studio/studio',["require", "exports", "../charts/multichart", "../tracks/starred", "../tracks/track-enabled", "../util/log", "./laser-edit", "./laser-list", "./studio-overlay", "./suit-panel", "./track-list"], function (require, exports, multichart_1, starred, trackEnabled, log, laser_edit_1, laser_list_1, studioOverlay, suit_panel_1, track_list_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var ViewState;
    (function (ViewState) {
        ViewState["Tracks"] = "tracks";
        ViewState["Profiles"] = "profiles";
        ViewState["NewProfile"] = "newprofile";
    })(ViewState || (ViewState = {}));
    var viewState = ViewState.Tracks;
    var chart;
    var trackList;
    var laserList;
    var laserEdit;
    var tracksButton;
    var profilesButton;
    var newProfileButton;
    // Tracks come from user, lasers from authUser
    function init(userId, authUserId) {
        // Load starred track data
        starred.init(userId);
        // Initialize flight profile chart
        chart = new multichart_1.MultiChart();
        chart.update();
        // Initialize panels
        trackList = new track_list_1.TrackList(userId, authUserId);
        laserList = new laser_list_1.LaserList(authUserId);
        laserEdit = new laser_edit_1.LaserEditor();
        var suitPanel = new suit_panel_1.SuitPanel(userId);
        suitPanel.clicks.subscribe(function () {
            // Standard zoom
            chart.zoomTo(-400);
        });
        // Chart overlay
        studioOverlay.init();
        // Starred tracks updates
        starred.updates.subscribe(function () { return chart.update(); });
        // Setup bindings
        trackEnabled.trackEnabled.subscribe(function () { return unwelcome(); });
        laserEdit.saves.subscribe(function () {
            laserList.update();
            setViewState(ViewState.Profiles);
        });
        // Hide new profile from unauthed users
        if (!authUserId) {
            document.getElementById("studio-new-profile").style.display = "none";
        }
        // Bind track/laser buttons
        tracksButton = document.getElementById("studio-view-tracks");
        profilesButton = document.getElementById("studio-view-profiles");
        newProfileButton = document.getElementById("studio-new-profile");
        tracksButton.addEventListener("click", function () { return setViewState(ViewState.Tracks); });
        profilesButton.addEventListener("click", function () { return setViewState(ViewState.Profiles); });
        newProfileButton.addEventListener("click", function () { return setViewState(ViewState.NewProfile); });
        document.getElementById("studio-clear-button").addEventListener("click", function () { return trackEnabled.removeAll(); });
        trackList.render();
        laserList.render();
        setViewState(ViewState.Tracks);
    }
    exports.init = init;
    function unwelcome() {
        document.getElementById("studio-welcome").style.display = "none";
    }
    function setViewState(state) {
        viewState = state;
        tracksButton.classList.remove("active");
        profilesButton.classList.remove("active");
        newProfileButton.classList.remove("active");
        trackList.element.classList.remove("active");
        laserList.element.classList.remove("active");
        laserEdit.element.classList.remove("active");
        switch (viewState) {
            case ViewState.Tracks:
                tracksButton.classList.add("active");
                trackList.element.classList.add("active");
                break;
            case ViewState.Profiles:
                profilesButton.classList.add("active");
                laserList.element.classList.add("active");
                break;
            case ViewState.NewProfile:
                newProfileButton.classList.add("active");
                laserEdit.element.classList.add("active");
                break;
        }
        log.info("studio tab " + state);
    }
});
//# sourceMappingURL=/assets/javascripts/studio/studio.js.map;
